import React, { useContext } from "react";
import PropTypes from "prop-types";
import { subscribe } from "venuescanner-js/react/helpers";
import SrpContainer from "../../containers/SrpContainer";
import classes from "./styles.module.scss";
import { SrpContext } from "../Filters/context";
import pinIcon from "./pin.svg";
import { $ } from "venuescanner-js/tools/elemental";

const MapToggle = ({ toggleMap }) => (
  <button type="button" className={classes.MapToggleButton} onClick={toggleMap}>
    <svg>
      <use xlinkHref={`${pinIcon}#pin`} />
    </svg>
    Toggle map
  </button>
);

MapToggle.propTypes = {
  toggleMap: PropTypes.func.isRequired,
};

export default subscribe({ SrpContainer })(({ srpContainer }) => {
  const { mapOpen, setMapOpen } = useContext(SrpContext);
  return (
    <MapToggle
      toggleMap={() => {
        $("body").toggleClass("ux-srp-expanded");
        setMapOpen(!mapOpen);
        if (srpContainer.map) {
          srpContainer.map.map.resize();
        }
      }}
    />
  );
});
